import React, { useState } from 'react';
import { DatePicker } from 'grab-ui';

// DatePickerWrapper as name suggests is a wrapper around DatePicker.
// DatePicker doesn't match its width to the input elements width set by user.
// DatePickerWrapper is used to solve above problem.
// DatePickerWrapper takes props and passes it to DatePicker thus supporting all features.
// DatePickerWrapper sets width of DatePicker element matching the input elements width.
// DatePickerWrapper handles opacity to avoid the sudden jerk in UI change.
const DatePickerWrapper = (props) => {
  const [uniqueClassName] = useState(new Date().getTime());
  return (<DatePicker
    className={uniqueClassName}
    popupStyle={{ opacity: '0' }}
    onOpenChange={(state) => {
      if (state) {
        const input = document.getElementsByClassName(uniqueClassName)[0];
        setTimeout(() => {
          const calendars = document.getElementsByClassName('ant-calendar');
          if (calendars && calendars.length > 0) {
            for (const calendar of calendars) {
              calendar.style.width = `${input.getBoundingClientRect().width}px`;
              if (calendar.parentNode) {
                calendar.parentNode.style.opacity = '1';
              }
            }
          }
        }, 0);
      }
    }}
    {...props}
  />);
};

export default DatePickerWrapper;
